import { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';

// services
import * as JulevennerService from '../../../../services/bb-api/red-cross/julevenner';
import type { UserCounts } from '../../../../services/bb-api/red-cross/julevenner';
import { notification } from 'antd';

export const TotalNumbers: React.FC = () => {
	const [totalUserCount, setTotalUserCount] = useState<UserCounts | null>(null);
	const [totalUserCount24h, setTotalUserCount24h] = useState<UserCounts | null>(null);
	const [totalUserHostCount, setTotalUserHostCount] = useState<UserCounts | null>(null);
	const [totalUserGuestCount, setTotalUserGuestCount] = useState<UserCounts | null>(null);

	const getData = useCallback(() => {
		try {
			JulevennerService.totalUserCount().then(setTotalUserCount);
			JulevennerService.totalUserCount24h().then(setTotalUserCount24h);
			JulevennerService.totalUserTypeCount('host').then(setTotalUserHostCount);
			JulevennerService.totalUserTypeCount('guest').then(setTotalUserGuestCount);
		} catch (error) {
			const message = 'Der skete en fejl';
			notification.error({ message });
		}
	}, [])

	useEffect(() => {
		getData();
		const intervalTime = 60 * 1000 // 1 min
		const intervalId = setInterval(getData, intervalTime)
		return () => clearInterval(intervalId)
	}, [getData]);

	return (
		<StyledContainer className='total-container'>
			<div className='num-container'>
				<h1>{totalUserCount?.postCount ?? 0}</h1>
				<p className='label'>Tilmeldinger</p>
				<p>Totalt</p>

				<div className='ac-num-container'>
					<div className='ac-num'>
						<p>{totalUserCount?.adultCount.toLocaleString() ?? 0}</p>
						<p>Voksne</p>
					</div>
					<div className='ac-num'>
						<p>{totalUserCount?.childCount.toLocaleString() ?? 0}</p>
						<p>Børn</p>
					</div>
				</div>
			</div>

			<div className='num-container'>
				<h1>{totalUserHostCount?.postCount.toLocaleString() ?? 0}</h1>
				<p className='label'>Værter</p>
				<div className='ac-num-container'>
					<div className='ac-num'>
						<p>{totalUserHostCount?.adultCount.toLocaleString() ?? 0}</p>
						<p>Voksne</p>
					</div>
					<div className='ac-num'>
						<p>{totalUserHostCount?.childCount.toLocaleString() ?? 0}</p>
						<p>Børn</p>
					</div>
				</div>
			</div>

			<div className='num-container'>
				<h1>{totalUserGuestCount?.postCount.toLocaleString() ?? 0}</h1>
				<p className='label'>Gæster</p>
				<div className='ac-num-container'>
					<div className='ac-num'>
						<p>{totalUserGuestCount?.adultCount.toLocaleString() ?? 0}</p>
						<p>Voksne</p>
					</div>
					<div className='ac-num'>
						<p>{totalUserGuestCount?.childCount.toLocaleString() ?? 0}</p>
						<p>Børn</p>
					</div>
				</div>
			</div>

			<div className='num-container'>
				<h1>{totalUserCount24h?.postCount ?? 0}</h1>
				<p className='label'>Tilmeldinger</p>
				<p>Sidste 24 timer</p>
				<div className='ac-num-container'>
					<div className='ac-num'>
						<p>{totalUserCount24h?.adultCount?.toLocaleString() ?? 0}</p>
						<p>Voksne</p>
					</div>
					<div className='ac-num'>
						<p>{totalUserCount24h?.childCount?.toLocaleString() ?? 0}</p>
						<p>Børn</p>
					</div>
				</div>
			</div>
		</StyledContainer>
	);
};

const StyledContainer = styled.div`
	display: flex;
	gap: 24px;
	align-items: center;
	justify-content: center;
	justify-items: center;
	color: #333333;

	h1 {
		font-size: 84px;
		font-weight: 700;
		line-height: 1em;
		margin: 0;
	}

	p {
		margin: 0;
	}

	.label {
		font-size: 32px;
		margin: 0;
	}

	.num-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		background-color: rgba(255, 255, 255, 0.8);
		backdrop-filter: blur(10px);
		width: 250px;
		height: 250px;
		padding: 12px 24px;
		border-radius: 12px;
		box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
	}

	.ac-num-container {
		display: flex;
		flex: 1;
		width: 100%;
		justify-content: space-around;
		align-items: flex-end;
	}

	.ac-num {
		display: flex;
		flex-direction: column;

		p {
			text-align: center;
		}

		p:first-child {
			font-weight: bold;
			font-size: 2em;
		}
	}
`;
